import { render, staticRenderFns } from "./CouponDetailTables.vue?vue&type=template&id=aa4f5f70&"
import script from "./CouponDetailTables.vue?vue&type=script&lang=js&"
export * from "./CouponDetailTables.vue?vue&type=script&lang=js&"
import style0 from "./CouponDetailTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports